import type {
  AuthenticationToolDef,
  AuthRequiredToolDef,
} from '@form-factory/schema/contracts';

import { MembershipLogin } from './membershipTool/components/MembershipLogin';
import { createToolComponent } from '../../toolRegistry';
import { Markdown } from '../Markdown';
import { Message } from '../ui';

export const AuthenticationTool = createToolComponent(
  {
    validate: false,
  },
  ({ toolCall, state }) => {
    if (state !== 'result') {
      return null;
    }

    const data = toolCall.content as
      | AuthenticationToolDef
      | AuthRequiredToolDef
      | undefined;

    if (!data) {
      return null;
    }

    const content = data.content;
    const shouldLogin =
      'requiresAuth' in data
        ? data.suggestedAction === 'login'
        : data.shouldLogin ||
          ('shouldRegister' in data && data.shouldRegister === true);

    if (shouldLogin) {
      return <MembershipLogin login={{ content, shouldLogin: true }} />;
    }

    return (
      <Message.BubbleGroup>
        <Message.Bubble>
          <Markdown>{content ?? ''}</Markdown>
        </Message.Bubble>
      </Message.BubbleGroup>
    );
  },
);
